import { Button, Icon } from '@perch-labs/shrike';
import { DialogOverlay, DialogContent } from '@reach/dialog';
import styled from 'styled-components';
import { layout, space, LayoutProps, SpaceProps } from 'styled-system';
import { Container } from '~/components/layout';

interface StyleProps extends LayoutProps, SpaceProps {}

export const Overlay = styled(DialogOverlay)`
  background-color: ${props => `${props.theme.colors.background.tertiary}98`};
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
`;

export const Body = styled(DialogContent)`
  background-color: ${props => props.theme.colors.background.primary};
  border-radius: 8px;
  box-shadow: 0 0 25px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-flow: column;
  height: 80%;
  margin: 0 auto;
  padding: 0;
  position: relative;
  min-width: 600px;
  max-width: 650px;

  ${props => props.theme.media.tabletPortraitDown} {
    border-radius: 0;
    margin: 0;
    min-height: 100%;
    min-width: unset;
    max-width: unset;
    width: 100%;
  }
`;

export const ButtonContainer = styled(Container).attrs({
  padding: 6,
})`
  align-items: center;
  display: flex;
  flex-flow: row-reverse;
  justify-content: space-between;
`;

export const Main = styled.main`
  border-bottom: 1px solid ${props => props.theme.colors.background.tertiary};
  flex-grow: 1;
  height: 70vh;
  overflow-y: auto;
  padding: 0 48px;

  ${props => props.theme.media.tabletPortraitDown} {
    width: 100%;
    padding: 0 24px;
  }
`;

export const CloseButton = styled(Button)`
  background: transparent !important;
  border: none !important;
  padding: 0 !important;
`;

export const CloseIcon = styled(Icon).attrs({
  icon: 'UIClose',
  scale: 3,
})``;

export const Content = styled.div<StyleProps>`
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: hidden;

  ${layout}
  ${space}

  ${props => props.theme.media.tabletPortraitDown} {
    padding: 0;
  }
`;
